import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../app/hooks/useAuth";
import useVoice from "../../../app/hooks/useVoice";
import { useSelector } from "react-redux";

const breadcrumbRoutes = [
  { path: "/", name: "Dashboard", aclName: "" },
  { path: "/users", name: "Users", aclName: "" },
  { path: "/settings", name: "Settings", aclName: "" },
  { path: "/profile", name: "Profile", aclName: "" },
  { path: "/reports", name: "Reports", aclName: "" },
  { path: "/editAccount", name: "Edit Account ", aclName: "" },
  {
    path: "/serviceTicketCreate",
    name: "New Service Request",
    aclName: "ServiceTicketsWidget",
  },
  {
    path: "/meterTicketCreate",
    name: "Create Gas Meter Install Request ",
    aclName: "",
  },
  {
    path: "/gasServiceTicketCreate",
    name: "Create Service Line Request",
    aclName: "",
  },
  {
    path: "/fiberServiceTicketCreate",
    name: "Create Fiber Service Ticket ",
    aclName: "",
  },
  {
    path: "/serviceTicketView",
    name: "View Service Ticket ",
    aclName: "ServiceTicketsWidget",
  },
  {
    path: "/serviceTicket",
    name: "My Service Requests ",
    aclName: "ServiceTicketsWidget",
  },
  { path: "/manageContacts", name: "Manage Users", aclName: "ManageContact" },
  {
    path: "/messageCenter",
    name: "Messages Center ",
    aclName: "MessageBoxWidget",
  },
  {
    path: "/billingHistory",
    name: "Billing Statements ",
    aclName: "BillingHistory",
  },
  {
    path: "/transactionHistory",
    name: "Transaction History",
    aclName: "TransactionHistory",
  },
  {
    path: "/paymentHistory",
    name: "Payment History ",
    aclName: "PaymentHistory",
  },
  { path: "/subAccounts", name: "Service Accounts ", aclName: "Accounts" },
  {
    path: "/managePayment",
    name: "Payment Methods",
    aclName: "ManagePaymentMethods",
  },
  {
    path: "/manageDocuments",
    name: "Manage Data Files ",
    aclName: "ManageDataFile",
  },
  { path: "/faq", name: "Faq ", aclName: "FAQS" },
  {
    path: "/resourceCenter",
    name: "Resource Center ",
    aclName: "ResourceCenter",
  },
  { path: "/support", name: "Support ", aclName: "" },
  { path: "/payment", name: "Payment ", aclName: "" },
  { path: "/paymentSuccess", name: "Payment Success ", aclName: "" },
  { path: "/properties", name: "Properties Page ", aclName: "Properties" },
  {
    path: "/gasUssageHistory",
    name: "Gas Ussage History ",
    aclName: "GasUsageHistory",
  },
  { path: "/voipCustomer", name: "VOIP Aliaze ", aclName: "" },
  { path: "/tvPin", name: "TV & GigaStream™ ", aclName: "" },
  { path: "/alianza", name: "Alianza ", aclName: "" },
  { path: "/contactUs", name: "Contact Us ", aclName: "ContactUs" },
  {
    path: "/securitySettings",
    name: "Security Settings",
    aclName: "SecuritySettings",
  },
  {
    path: "/managePreference",
    name: "Notification Preferences",
    aclName: "AccountPreferences",
  },
  {
    path: "/fiberOperations/network",
    name: "Fiber Operations - Network",
    aclName: "NetWork",
  },
  {
    path: "/fiberOperations/onts",
    name: "Fiber Operations - ONTs",
    aclName: "Onts",
  },
  {
    path: "/fiberOperations/subscriber",
    name: "Fiber Operations - Subscriber",
    aclName: "Subscriber",
  },
  {
    path: "/manageAnnouncements",
    name: "Manage Accouncements",
    aclName: "ManageAnnouncements",
  },
  {
    path: "/depositAccounts",
    name: "Account Deposits",
    aclName: "AccountDeposits",
  },
  {
    path: "/issueCredit",
    name: "Credit Adjustments",
    aclName: "CreditAdustments",
  },
  {
    path: "/disconnection",
    name: "Dunning Disconnects",
    aclName: "DunningDisconnects",
  },
  {
    path: "/dailySales",
    name: "Daily Sales",
    aclName: "DunningDisconnects",
  },
  {
    path: "/reportGeneration",
    name: "Report Generation",
    aclName: "DunningDisconnects",
  },
  {
    path: "/enrollmentQueue",
    name: "EnrollmentQueue",
    aclName: "EnrollmentQueue",
  },
  {
    path: "/bulksmxsfupdate",
    name: "Bulk SMX SF Update",
    aclName: "EnrollmentQueue",
  },
  {
    path: "/enrollmentApp",
    name: "Enrollment App",
    aclName: "EnrollmentQueue",
  },
  {
    path: "/manage-myaccount-users",
    name: "Manage Internal Users",
    aclName: "ManageInternalUsers",
  },
  {
    path: "/manageFiberService",
    name: "Manage Fiber Service",
    aclName: "MessageQueue",
  },
  {
    path: "/fiberEnrollmentIssue",
    name: "Fiber Enrollment Issue",
    aclName: "MessageQueue",
  },
  {
    path: "/communityManagement",
    name: "Manage Community ",
    aclName: "MessageQueue",
  },
  {
    path: "/messageQueue",
    name: "Message Queue",
    aclName: "MessageQueue",
  },
  {
    path: "/myAcclogin",
    name: "Manage My-Account Login",
    aclName: "ManageMyAccount",
  },
  {
    path: "/home",
    name: "Operations Summary",
    aclName: "",
  },
  {
    path: "/fiber-service",
    name: "Fiber service",
    aclName: "FiberSettings",
  },
  {
    path: "/admin/settings",
    name: "Access Control  ",
    aclName: "AccessControl",
  },
  { path: "/not-found", name: "Not Found ", aclName: "" },
];

const Breadcrumb = () => {
  const navigate = useNavigate();
  const { getAcl } = useAuth();
  const location = useLocation();
  const { isListening, listen } = useVoice();

  const { selectedAddressServiceAccount, userAccountDetails } = useSelector((state) => state?.userDetailSlice);

  const selectedAccount = useSelector(
    (state) => state?.userDetailSlice?.selectedAccount,
  );

  const [userLoginInfo, setUserLoginInfo] = useState(null);

  const { userTypeCode } = userLoginInfo || {};
  const { first_name, last_name } = userAccountDetails?.userAccountInfo || {};

  const nameStyle = {
    fontWeight: "bold",
    padding: "5px",
    right: "50px"
  };



  useEffect(() => {
    setUserLoginInfo(userAccountDetails?.userLoginInfo);
  }, [userAccountDetails]);

  const currentBreadcrumb =
    breadcrumbRoutes.find((route) => route.path === location.pathname)?.name ||
    "";
  const aclName = breadcrumbRoutes.find(
    (route) => route.path === location.pathname,
  )?.aclName;

  useEffect(() => {
    if (aclName && getAcl("MyProfileWidget").read === true) {
      if (!getAcl(aclName).read) {
        navigate("/not-found");
      }
    }
  }, [selectedAccount?.roles, aclName]);


  const serviceSuspended = (selectedAddressServiceAccount?.user_accounts || [])
    .some((acc) => acc.status === "SUSPEND")


  return (
    <div className="toolbar" id="kt_toolbar">
      <div
        id="kt_toolbar_container"
        className="container-fluid d-flex flex-stack"
      >
        <div className="toolbar-left">
          <div className="page-title">{currentBreadcrumb}</div>
          <span>|</span>
          <div className="d-flex align-items-center py-1 breadcrumb_wrapper">
            <ul className="breadcrumb">
              <li>
                <a
                  // href="void(0)"
                  onClick={() => navigate("/")}
                  className="breadcrumb-link cursor-pointer cp"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  // href="void(0)"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(location.pathname)}
                  className="cp"
                >
                  {currentBreadcrumb}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="d-flex align-items-stretch flex-shrink-0 right topbar">
          <div className="d-flex align-items-start flex-shrink-0">
            {userTypeCode === "CENTRIC" && first_name && last_name && (
              <span style={nameStyle}>
                User Name: {first_name} {last_name}
              </span>
            )}
          </div>

          <div className="d-flex align-items-start flex-shrink-0">
            {selectedAddressServiceAccount && serviceSuspended &&
              <span style={{ backgroundColor: "red", color: "white", padding: "5px" }}>{"SHUT OFF NON PAY"}</span>
            }
            {/* <div className="d-flex align-items-stretch cart">
              <AddToCart />
            </div> */}
            {/* <div className="d-flex align-items-stretch ">
              <div className="cart d-flex align-items-stretch">
                <div className="d-flex align-items-center">
                  <a
                    href="void(0)"
                    className="item-icons"
                    onClick={async (e) => {
                      e.preventDefault();
                      await listen(!isListening);
                    }}
                  >
                    <i
                      className={`fa-solid fa-microphone ${
                        isListening ? "mic-icon-on" : "mic-icon-off"
                      }`}
                    ></i>
                  </a>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
